import * as React from 'react';
import { Route, RouteProps, Redirect, RouteComponentProps } from 'react-router-dom';
import { UserRoles } from '../../models/UserRole';
import UserDetails from '../../models/UserDetails';
import SearchListData from 'src/models/SearchListData';

// tslint:disable-next-line
type RouteComponent = React.FunctionComponent<RouteComponentProps<{}>> | React.ComponentClass<any>;

export interface IRouterPrivateProps {
    isLoggedIn: boolean;
    roles?: Array<UserRoles>;
    user?: UserDetails;
    searchFilterData?: SearchListData[];
    filterTownships?: boolean;
    filterTracts?: boolean;
    refreshTags?: () => void;
    showPanel?: (show: boolean) => void;
}

const RoutePrivate: React.FunctionComponent<RouteProps & IRouterPrivateProps> = ({ component, ...rest }) => {
    const renderFn = (Component?: RouteComponent) => (props: RouteComponentProps) => {
        if (!Component) {
            return null;
        }

        return rest.isLoggedIn ? <Component {...{...props, ...rest}} /> : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
    };

    return <Route {...rest} render={renderFn(component)} />;
};

export default RoutePrivate;



// WEBPACK FOOTER //
// ./src/components/router/RoutePrivate.tsx